// 🔧 organization_diagnostics_panel.js
// ✅ Purpose: Displays Organization Engine diagnostics
// ✅ Features:
// - Shows informational diagnostics
// - Future-ready for Organization Engine health/audit
// - Consistent Platform Console styling
//
// ✅ Notes:
// - Presentation only
// - Future versions will consume Organization Engine diagnostics

import React from "react";

const OrganizationDiagnosticsPanel = ({
  organization,
}) => {

  //--------------------------------------------------------
  // Build diagnostic list
  //--------------------------------------------------------

  const diagnostics = [];

  if (!organization.ownerUid) {

    diagnostics.push({

      level: "warning",

      message:
        "No organization owner is assigned.",

    });

  }

  if (!organization.organizationSlug) {

    diagnostics.push({

      level: "warning",

      message:
        "Organization slug is missing.",

    });

  }

  if (!organization.organizationType) {

    diagnostics.push({

      level: "warning",

      message:
        "Organization type has not been configured.",

    });

  }

  if (
    (organization.eventCount ?? 0) === 0
  ) {

    diagnostics.push({

      level: "info",

      message:
        "No events are currently linked to this organization.",

    });

  }

  //--------------------------------------------------------
  // Render
  //--------------------------------------------------------

  return (

    <div className="card shadow-sm">

      <div className="card-header bg-white">

        <strong>

          Diagnostics

        </strong>

      </div>

      <div className="card-body">

        {diagnostics.length === 0 ? (

          <div className="text-success">

            ✅ No diagnostic issues detected.

          </div>

        ) : (

          diagnostics.map((item, index) => (

            <div
              key={index}
              className={`alert mb-2 ${
                item.level === "warning"
                  ? "alert-warning"
                  : "alert-info"
              }`}
            >

              {item.message}

            </div>

          ))

        )}

      </div>

    </div>

  );

};

export default OrganizationDiagnosticsPanel;